import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = { expiresAt: String }

  connect() {
    this.updateCountdown()
    this.interval = setInterval(() => this.updateCountdown(), 60000) // Update every minute
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateCountdown() {
    if (!this.expiresAtValue || !this.hasDisplayTarget) return

    const expiresAt = new Date(this.expiresAtValue)
    const now = new Date()
    const diff = expiresAt - now

    if (diff <= 0) {
      this.displayTarget.textContent = "Expired"
      this.element.classList.remove("bg-yellow-50", "border-yellow-200")
      this.element.classList.add("bg-red-50", "border-red-200")

      // Update icon color
      const icon = this.element.querySelector("i")
      if (icon) {
        icon.classList.remove("text-yellow-600")
        icon.classList.add("text-red-600")
      }

      // Update text colors
      this.element.querySelectorAll(".text-yellow-800, .text-yellow-900").forEach(el => {
        el.classList.remove("text-yellow-800", "text-yellow-900")
        el.classList.add("text-red-800")
      })
      this.element.querySelectorAll(".text-yellow-700").forEach(el => {
        el.classList.remove("text-yellow-700")
        el.classList.add("text-red-700")
      })

      return
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

    let displayText
    if (days > 0) {
      displayText = `${days} day${days > 1 ? 's' : ''}`
    } else if (hours > 0) {
      displayText = `${hours} hour${hours > 1 ? 's' : ''}`
    } else if (minutes > 0) {
      displayText = `${minutes} minute${minutes > 1 ? 's' : ''}`
    } else {
      displayText = "Less than a minute"
    }

    this.displayTarget.textContent = displayText

    // Add urgency styling for last 24 hours
    if (days === 0 && hours < 24) {
      this.element.classList.remove("bg-yellow-50", "border-yellow-200")
      this.element.classList.add("bg-orange-50", "border-orange-200")

      const icon = this.element.querySelector("i")
      if (icon) {
        icon.classList.remove("text-yellow-600")
        icon.classList.add("text-orange-600")
      }
    }
  }
}
